export default function Services() {
  const services = [
    {
      label: 'DEVELOPMENT',
      title: 'iOS App Development',
      description: 'Custom iOS applications built with Swift and the latest Apple technologies, ensuring optimal performance and seamless user experience.',
      color: '#7c3aed'
    },
    {
      label: 'SECURITY',
      title: 'Security Solutions',
      description: 'Advanced encryption and security protocols to protect user data and ensure privacy across all our applications and services.',
      color: '#0ea5e9'
    },
    {
      label: 'OPTIMIZATION',
      title: 'Performance Optimization',
      description: 'Comprehensive device optimization services that enhance speed, efficiency, and overall mobile device performance.',
      color: '#10b981'
    },
    {
      label: 'SUPPORT',
      title: 'Technical Support',
      description: 'Dedicated customer support and maintenance services to ensure your applications run smoothly and stay up-to-date.',
      color: '#f59e0b'
    }
  ];

  return (
    <section className="bg-[#FAF8F5] py-[220px]">
      <div className="px-[120px]">
        <h2 className="text-[52px] font-bold text-[#2C2416] mb-24" style={{ marginLeft: '20%' }}>
          Services
        </h2>

        <div className="grid grid-cols-2 gap-12 max-w-6xl mx-auto">
          {services.map((service, index) => (
            <div
              key={service.title}
              className={`bg-white rounded-[28px] p-12 shadow-sm hover:shadow-md transition-shadow relative ${
                index % 2 === 0 ? 'w-[480px]' : 'w-[580px]'
              } ${index >= 2 ? '-mt-20' : ''} ${index % 2 === 1 ? 'ml-auto' : ''}`}
              style={{ minHeight: '320px' }}
            >
              {/* Decorative corner accent */}
              <div
                className="absolute top-0 right-0 w-1 h-10 rounded-bl"
                style={{ backgroundColor: service.color }}
              ></div>

              {/* Label */}
              <div className="text-xs uppercase tracking-widest text-gray-500 mb-10">
                {service.label}
              </div>

              {/* Title */}
              <h3 className="text-[28px] font-semibold text-[#1C1C1E] mb-8">
                {service.title}
              </h3>

              {/* Description */}
              <p className="text-base leading-[26px] text-[#6B6B6B]">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}